import { IChuongTrinhDaoTaoNhomTuChon } from "../../model/respone/ctdt/IChuongTrinhDaoTaoNhomTuChon";
import { apiClient } from "../apiClient";
import { CHUONG_TRINH_DAO_TAO_ENDPOINT } from "./chuongTrinhDaoTaoApi";

export const CHUONG_TRINH_DAO_TAO_NHOMTUCHON_ENDPOINT = "ctdt-nhom-tu-chon";

export const chuongTrinhDaoTaoNhomTuChonApi = {
    SelectByCtdt: (id_dt: number) =>
        apiClient.get(`${CHUONG_TRINH_DAO_TAO_ENDPOINT}/${id_dt}/nhom-tu-chon`),
    InsertOrUpdate: (payload: IChuongTrinhDaoTaoNhomTuChon) =>
        apiClient.post(`${CHUONG_TRINH_DAO_TAO_NHOMTUCHON_ENDPOINT}`, payload),
};
